import {Extension, mergeAttributes, Node} from '@tiptap/core'

export const Indent = Node.create({
    name: 'indent',

    // must not have anything else than 'text*'
    content: 'text*',

    inline: true,

    // add to 'inline' group
    group: 'inline',

    // Element is draggable
    draggable: true,

    // Element is selectable
    selectable: true,

    atom: true,

    addAttributes() {
        return {
            value: {
                default: null,
                parseHTML: () => '&nbsp;&nbsp;&nbsp;&nbsp;',
                renderHTML: () => {
                    return {
                        contenteditable: false,
                    };
                },
            },
        };
    },

    parseHTML() {
        return [{ tag: 'indent' }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'indent',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0,
        ];
    },
})

export const AddIndent = Extension.create({
    name: 'add_indent',
    addCommands() {
        return {
            addIndent:
                () =>
                    ({ commands }) => {
                        commands.insertContent('<indent>&nbsp;&nbsp;&nbsp;&nbsp;</indent>')

                        return false;
                    },
        };
    },

    addKeyboardShortcuts() {

        return {
            Tab: () => {
                if (this.editor.can().addRowBefore()) {
                    return false
                }

                this.editor.commands.addIndent();

                this.editor
                    .chain()
                    .focus();

                return true;
            },
        }
    },
});
